import { Box, AccordionDetails, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { CaseHistoryResponseDto } from '@bandido/shared/dtos';
import { StyledAccordion, StyledAccordionSummary } from './styled';
import { CaseLogFields } from '@bandido/shared/constants';

interface LogEntryProps {
  log: CaseHistoryResponseDto;
}

export const LogEntry = ({ log }: LogEntryProps) => {
  const { t } = useTranslation();
  const { caseLogAction, caseLogWhat, caseLogFrom, caseLogTo, createdAt } = log;
  const createdAtTime = dayjs(createdAt).format('HH:mm');

  return (
    <StyledAccordion>
      <StyledAccordionSummary>
        <Box display="flex" width="100%" gap={1} alignItems="center">
          <Typography color="text.disabled" variant="body2">

            {log.caseLogWhat !== CaseLogFields.SALEORDER ? t(`cases.view.log.${caseLogWhat}`): t(`cases.view.log.saleorder.${caseLogAction}`)}:
          </Typography>
          <Typography
            sx={{
              maxWidth: 200,
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
            }}
            color="text.primary"
            variant="body2"
          >
            {caseLogTo ?? t('common.unassigned')}
          </Typography>
          <Typography component="div" flex={1} textAlign="right" color="text.disabled" variant="subtitle2">
            {createdAtTime}
          </Typography>
        </Box>
      </StyledAccordionSummary>
      {
        log.caseLogWhat !== CaseLogFields.SALEORDER && (
          <AccordionDetails>
            <Box display="flex" gap={0.5} alignItems="center">
              <Typography textTransform="capitalize" variant="body2">
                {t(`cases.view.log.${caseLogAction}`)}
              </Typography>
              <Typography fontWeight={(theme) => theme.typography.fontWeightMedium} variant="body2">
                {t(`cases.view.log.${caseLogWhat}`)}
              </Typography>
    
              <>
                <Typography variant="body2">{t('cases.view.log.from')}</Typography>
                <Typography variant="body2">&quot;{caseLogFrom ?? t('common.unassigned')}&quot;</Typography>
              </>
    
              <>
                <Typography variant="body2">{t('cases.view.log.to')}</Typography>
                <Typography variant="body2">&quot;{caseLogTo ?? t('common.unassigned')}&quot;</Typography>
              </>
            </Box>
          </AccordionDetails>
        )
      }
    </StyledAccordion>
  );
};
